import { isMasterRecordSelectable } from './masterRecordStatus';

export type RestaurantComplianceFieldKey = 'gstNumber' | 'fssaiNumber' | 'tradeLicenseNumber';

export type RestaurantComplianceRequirements = {
  gstNumber: boolean;
  fssaiNumber: boolean;
  tradeLicenseNumber: boolean;
};

type MerchantDocumentTypeRow = {
  code?: string;
  name?: string;
  isActive?: boolean;
  metadata?: Record<string, unknown>;
};

function normCode(value: string) {
  return value.toLowerCase().replace(/[^a-z0-9]/g, '');
}

function entityTypesIncludeMerchant(raw: unknown): boolean {
  if (Array.isArray(raw)) {
    return raw.map(String).some((v) => v.toLowerCase().includes('merchant'));
  }
  return String(raw || '').toLowerCase().includes('merchant');
}

function isTruthyFlag(raw: unknown): boolean {
  return raw === true || raw === 'true' || raw === 1 || raw === '1';
}

function mapDocCodeToField(code: string): RestaurantComplianceFieldKey | null {
  const n = normCode(code);
  if (n.includes('gst')) return 'gstNumber';
  if (n.includes('fssai') || n.includes('foodlicense')) return 'fssaiNumber';
  if (n.includes('trade') || n.includes('shopact')) return 'tradeLicenseNumber';
  return null;
}

/**
 * Derive which restaurant compliance number fields are required from
 * Merchant / Vendor Document master rules (required + applies to merchant).
 */
export function resolveRestaurantComplianceRequirements(
  rows: MerchantDocumentTypeRow[] | undefined | null,
): RestaurantComplianceRequirements {
  const req: RestaurantComplianceRequirements = {
    gstNumber: false,
    fssaiNumber: false,
    tradeLicenseNumber: false,
  };

  for (const row of rows || []) {
    if (!isMasterRecordSelectable(row)) continue;
    const meta = row.metadata || {};
    if (!isTruthyFlag(meta.required)) continue;
    if (!entityTypesIncludeMerchant(meta.entityTypes)) continue;
    const field = mapDocCodeToField(String(row.code || row.name || ''));
    if (field) req[field] = true;
  }

  return req;
}

export function complianceFieldLabel(field: RestaurantComplianceFieldKey): string {
  if (field === 'gstNumber') return 'GST Number';
  if (field === 'fssaiNumber') return 'FSSAI Number';
  return 'Trade License';
}
